import type { CreateUserParams } from '@/tygo/db'
import type { AuthResponse } from '@/tygo/dto'
import { apiFetch } from '@/lib/http'

const AUTH_BASE = '/api/v1/auth'

export type LoginParams = {
  email: string
  password: string
}

export function refresh(input: { refresh_token: string }) {
  return apiFetch<AuthResponse>(`${AUTH_BASE}/refresh`, {
    method: 'GET',
    headers: {
      cookie: `refresh_token=${input.refresh_token}`,
    },
  })
}

export function signup(input: CreateUserParams) {
  return apiFetch<AuthResponse>(`${AUTH_BASE}/signup`, {
    method: 'POST',
    body: JSON.stringify(input),
    skipRefresh: true,
  })
}

export function login(input: LoginParams) {
  return apiFetch<AuthResponse>(`${AUTH_BASE}/login`, {
    method: 'POST',
    body: JSON.stringify(input),
    skipRefresh: true,
  })
}

export function logout() {
  return apiFetch<void>(`${AUTH_BASE}/logout`, {
    method: 'POST',
  })
}
